<template>
    <section
        v-if="trendingGames.length"
        :class="$style.section"
        :data-interface-section="trendingCategory.id"
    >
        <ShelfTitle
            :title="trendingCategory.title"
            :link="trendingCategory.location"
            categoryId="trending_now"
        />
        <GeneralShelf
            :games="trendingList"
            :link="trendingCategory.location"
            :gameLinkTarget="undefined"
            :ctrContexts="trendingCtrContexts"
            embedded
            :categoryName="trendingCategory.title"
        />
    </section>
</template>
<script lang="ts" setup>
import { computed, onServerPrefetch } from 'vue'

import GeneralShelf from '@/components/GamesShelf/GeneralShelf.vue'
import ShelfTitle from '@/components/GamesShelf/ShelfTitle.vue'
import { useCtrListContexts } from '@/composables/use-ctr-context'
import { useTrendingData } from '@/query/use-trending-data'

const {
    currentTrending: trendingCategory,
    unzippedTrendingWithGames: trendingGames,
    preloadTrendingData,
} = useTrendingData()

const trendingList = computed(() => trendingGames.value.slice(0, 9))
const trendingCtrContexts = useCtrListContexts(
    () => trendingList.value,
    () => ({ placement: 'trending_now_404' }),
)

onServerPrefetch(async () => {
    try {
        await preloadTrendingData()
    } catch (error) {
        console.error('Failed to preload trending data for 404 page:', error)
    }
})
</script>
<style module>
.section {
    margin-top: 40px;
    margin-bottom: 24px;
}
</style>
